
<template>
  <div ref="listWrap">
    <wrapper-list
      @add="paasAddPage"
      @calculate="paasCalculate"
      ref="wrapperList" >
      <Form class="list-query-wrap" slot="query" :model="queryParam" :label-width="defaultLabelWidth" ref="queryForm">
        <row class="list-query-row">
          <FormItem label="分类名称" class="list-query-item">
            <Input  v-model="queryParam.query_LIKE_name" placeholder=""
                    @on-change="queryTableDatas" clearable />
          </FormItem>
          <FormItem label="状态" class="list-query-item">
            <Enum :enumJsonKey="'crmdict-isShow'"  v-model="queryParam.query_EQ_info"
                  @on-change="queryTableDatas">
            </Enum>
          </FormItem>
        </row>
      </Form>
      <Table slot="table" stripe border :height="tableHeight"
             :data="tableData"
             :columns="tableColumns"
             @on-selection-change="selectTableDataChange"
             @on-sort-change="sortTableData"
             :no-data-text="noDataText">
      </Table>
      <Page slot="page"  :total="totalRecords"
            show-total show-sizer
            @on-change="changePage"
            @on-page-size-change="changePageSize">
      </Page>
    </wrapper-list>
  </div>
</template>
<script>
  import wrapperList from "@/components/paas/wrapper-list";
  import metaList from "@/assets/js/list/meta-list.js";
  import EnumShow from "@/components/paas/enum-show";  //如果有枚举，需要引入
  import Enum from '@/components/paas/query-enum' //枚举查询
  import CellBar from '@/components/paas/cell-bar' //列表内操作
  export default {
    name: "list",
    mixins: [ metaList ],
    components: { wrapperList,EnumShow  ,Enum,CellBar},
    data() {
      return {
        serviceUrl:"/eb/system/config/tab",  //每个页面访问后台服务器的路径
        currentIdFiledName: 'id',
        queryParam:{
          query_LIKE_name:'',
          query_EQ_info:'',
        },
        defaultLabelWidth:200,
        tableColumns:[
          {
            type: 'index',  //type: 'index'，可以排序
            width: 40,
            align: 'center',
          },
          {
            title: '分类名称',
            key: 'name',
          },
          {
            title: '分类字段',
            key: 'engTitle',
          },
          {
            title: '类型',
            key: 'type',
            render:(h,params)=>{
              return h(EnumShow,{
                props:{
                  enumGroupCode:'crmdict',
                  enumCode:'configType',
                  value:params.row.type
                }
              })
            }
          },
          {
            title: '是否显示',
            key: 'info',
            render:(h,params)=>{
              return h(EnumShow,{
                props:{
                  enumGroupCode:'crmdict',
                  enumCode:'isShow',
                  value:params.row.info
                }
              })
            }
          },
          {
            title: '操作',
            render: (h, params) => {
              return h(CellBar,
                {
                  props:{
                    show:'textIcon'  //操作也显示标准按钮的样式（text、icon、textIcon）
                  },
                  //自定义事件监听器“on”,不支持如v-on:keyup.enter的修饰符，需要手动匹配keyCode
                  on: {
                    // 子组件$emit传递函数,必须是箭头函数写法
                    'edit': ()=> {
                      this.$nextTick(()=>{
                        this.paasEditOper(params.row[this.currentIdFiledName]);
                      })
                    },
                    'delete':()=>{
                      this.$nextTick(()=>{
                        this.paasDeleteOper(params.row[this.currentIdFiledName]);
                      })
                    },
                    'addConfig':()=>{
                      this.$nextTick(()=>{
                        let url = "/eb/system/config/create?configTabId="+params.row.id+"&configTabName="+params.row.name
                        this.$router.push({'path': this.setUrlFuncId(url)});
                      })
                    }
                  }
                }
              )
            }
          }
        ],
      }
    },
    mounted(){
    },
    methods:{
    }
  }
</script>
